import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { TokenService } from './token.service';
import { Observable } from 'rxjs';
import { BYPASS_AUTH_HEADER } from '../httpConfig/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthHtppInterceptorServiceService implements HttpInterceptor {
  constructor(
    private tokenService: TokenService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(BYPASS_AUTH_HEADER) || this.isPublicAuthRequest(req.url)) {
      return next.handle(req);
    }

    req = req.clone({
      headers: this.tokenService.createTokenHeader(req.headers)
    });
    return next.handle(req);
  }

  private isPublicAuthRequest(url: string): boolean {
    const normalizedUrl = url.toLowerCase();
    return normalizedUrl.includes('/authenticate')
      || normalizedUrl.includes('/auth/refresh')
      || normalizedUrl.includes('/auth/logout')
      || normalizedUrl.includes('/tenant/domain/')
      || normalizedUrl.includes('/tenant/username/');
  }
}
